import { WorkStatus } from './types';

export const DEFAULT_STATUS: WorkStatus = {
  day: '',
  statusValue: 'No data',
  isAvailable: false,
  closes: '',
};
